const baseURL =
  process.env.NODE_ENV === "production"
    ? `${process.env.REACT_APP_SERVICE_URL}api/`
    : `${process.env.REACT_APP_SERVICE_URL_DEV}api/`;

export const paramsSystem = {
  URLBASE: baseURL,
};
